import React, { useState } from 'react'
import './StarRating.css'

interface StarRatingProps {
  rating: number
  onRatingChange?: (rating: number) => void
  readonly?: boolean
  size?: 'small' | 'medium' | 'large'
}

const StarRating: React.FC<StarRatingProps> = ({
  rating,
  onRatingChange,
  readonly = false,
  size = 'medium'
}) => {
  const [hoverRating, setHoverRating] = useState(0)

  const handleClick = (value: number) => {
    if (!readonly && onRatingChange) {
      onRatingChange(value)
    }
  }

  const handleMouseEnter = (value: number) => {
    if (!readonly) {
      setHoverRating(value)
    }
  }

  const handleMouseLeave = () => {
    setHoverRating(0)
  }

  const displayRating = hoverRating || rating

  return (
    <div
      className={`star-rating star-rating-${size} ${readonly ? 'readonly' : ''}`}
      role="group"
      aria-label={readonly ? `Rating: ${rating} out of 5 stars` : 'Rate this recipe'}
    >
      {[1, 2, 3, 4, 5].map((value) => (
        <button
          key={value}
          type="button"
          className={`star ${value <= displayRating ? 'filled' : 'empty'}`}
          onClick={() => handleClick(value)}
          onMouseEnter={() => handleMouseEnter(value)}
          onMouseLeave={handleMouseLeave}
          disabled={readonly}
          aria-label={`${value} star${value !== 1 ? 's' : ''}`}
          tabIndex={readonly ? -1 : 0}
        >
          {value <= displayRating ? '★' : '☆'}
        </button>
      ))}
      {!readonly && (
        <span className="rating-text">
          {displayRating > 0 ? `${displayRating} star${displayRating !== 1 ? 's' : ''}` : 'Click to rate'}
        </span>
      )}
    </div>
  )
}

export default StarRating
